import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { DeprecatedTextAreaAutosize } from '../..';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { deprecatedTextAreaAutosizeKey } from './text-area-autosize';
export var createDeprecatedTextAreaAutosizeLegacyDriver = function (wrapper) {
    // tslint:disable-next-line: max-line-length
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, "." + deprecatedTextAreaAutosizeKey, DeprecatedTextAreaAutosize.name);
    var textArea = baseDriver.elem;
    return {
        getValue: function () { return textArea.value; },
        enterValue: function (value) { return baseDriver.enterValue(value); },
        isDisabled: function () { return textArea.hasAttribute('disabled'); },
        isReadOnly: function () { return textArea.hasAttribute('readonly'); }
    };
};
// tslint:disable-next-line: max-line-length
export var createDeprecatedTextAreaAutosize = function (props) {
    var elem = renderAndMountComponent(React.createElement(DeprecatedTextAreaAutosize, __assign({}, props)));
    return createDeprecatedTextAreaAutosizeLegacyDriver(elem);
};
//# sourceMappingURL=text-area-autosize.legacy-driver.js.map